import { render } from "./Multiple.vue?vue&type=template&id=4520590e&scoped=true"
import script from "./Multiple.vue?vue&type=script&lang=js"
export * from "./Multiple.vue?vue&type=script&lang=js"

import "./Multiple.vue?vue&type=style&index=0&id=4520590e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4520590e"]])

export default __exports__